import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthApi } from '@sb/shared/auth/data-access';
import { SbDialogService } from '@sb/ui/dialog';
import { take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailVerificationService {
  private api = inject(AuthApi);
  private dialog = inject(SbDialogService);
  private translate = inject(TranslateService);

  sendVerificationMail(): void {
    void this.api
      .sendVerificationMail()
      .pipe(
        take(1),
        tap(() => {
          this.dialog.openAnnouncement({
            title: this.translate.instant('Check Your Email!'),
            description: this.translate.instant(
              'We have sent you a new verification email. It should arrive in your inbox shortly.',
            ),
            image: {
              src: 'assets/images/announcement/checkmark.svg',
            },
            primary: {
              text: this.translate.instant('Okay'),
            },
          });
        }),
      )
      .subscribe();
  }
}
